<template>
  <vs-row style="margin-top: 15%" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
          <div id="b" style="padding: 3% 3% 0">
            <h3 class="ml-2" style="font-weight: 600">
              Think of your own IoT facility management.<a
                href=""
                style="font-size: 150%"
                class="header-anchor ml-2"
                >Think Sentenance</a
              >
            </h3>
            <h5 class="mt-3 ml-2">
              The most flexible IoT wireless sensor and facility automation
              system.
            </h5>
            <br />
          </div>
        </vs-col>

        <vs-row id="b" vs-w="12">
          <vs-col id="b" vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12">
            <div style="padding: 0 3%">
              <vs-button
                id="b"
                color="success"
                style="border-radius: 20px"
                target
                href="https://www.sentenance.com/"
                type="flat"
                ><h5>Learn More</h5></vs-button
              >
            </div>
            <vs-spacer />
            <div id="b" style="max-width: 50%; height: auto">
              <b-img
                :src="
                  require('@/assets/images/logo/undraw_progressive_app.png')
                "
                fluid
                style="background: #f6f6f6"
                alt="Fluid image"
              ></b-img>
            </div>
          </vs-col>
        </vs-row>
      </vs-row>
</template>

<script>
export default {

}
</script>

<style>

</style>